module.exports = __webpack_public_path__ + "img/intro6.3acca532.jpeg";